const strings = {
  title: 'Sumário de Validação',
}

export default strings
